module.exports = __webpack_public_path__ + "static/media/Foto_(10).983abf7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(10).jpg
// module id = 525
// module chunks = 0